export class Donor {
    name?: string
    phone?: string
    email?: string
    address?: string
    city?: string
    state?: string
    zip?: string
}
